import React from "react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { fileUrl } from "@/lib/api";
import { X } from "lucide-react";

/**
 * Reusable high-resolution image lightbox. Pass `src` (a storage path or
 * URL) and a `caption` to surface the original AI-camera photo behind
 * any ledger entry — Invoices Queue, Supplier Debt Matrix, Cheque
 * Calendar, Z-Reports, Cashflow vouchers.
 */
export default function ImageLightbox({ src, caption, open, onClose }) {
  if (!src) return null;
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent
        className="max-w-5xl bg-slate-950 border-slate-800 p-4"
        data-testid="image-lightbox"
      >
        <DialogTitle className="sr-only">{caption || "Receipt photo"}</DialogTitle>
        <button
          onClick={onClose}
          className="absolute top-3 right-3 h-9 w-9 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center"
          aria-label="Close"
          data-testid="lightbox-close"
        >
          <X className="h-5 w-5" />
        </button>
        <img
          src={fileUrl(src)}
          alt={caption || "Receipt"}
          className="max-h-[80vh] w-full object-contain rounded"
          data-testid="lightbox-image"
        />
        {caption && (
          <div
            className="mt-3 text-center font-mono text-xs text-slate-300"
            data-testid="lightbox-caption"
          >
            {caption}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
